import { styled } from "@pigment-css/react";

const List = styled("dl")(({ theme }) => ({
  margin: 0,
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[8],
}));

const Row = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.fieldSalesTwo.spacing[8],
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size["13"],
  fontWeight: theme.fieldSalesTwo.font.weight["500"],
  lineHeight: theme.fieldSalesTwo.font.lineHeight["130"],
  letterSpacing: theme.fieldSalesTwo.font.letterSpacing.wide,
  color: theme.fieldSalesTwo.colors.neutral[800],
  "& dd": { margin: 0 },
}));

export interface ComparisonLegendRow {
  /** Period name, e.g. "Aktuell" / "Vorperiode". */
  label: string;
  /** Formatted date range of that period. */
  range: string;
}

export function ComparisonLegend({ rows }: { rows: ComparisonLegendRow[] }) {
  return (
    <List>
      {rows.map((row) => (
        <Row key={row.label}>
          <dt>{row.label}</dt>
          <dd>{row.range}</dd>
        </Row>
      ))}
    </List>
  );
}
